import FreightBookingValidation from "@/classes/bookings/FreightBookingValidation";
import CourierBookingValidation from "@/classes/bookings/CourierBookingValidation";
import PreJobAirBookingValidation from "@/classes/bookings/PreJobAirBookingValidation";
import PreJobSeaBookingValidation from "@/classes/bookings/PreJobSeaBookingValidation";
import PreJobRoadBookingValidation from "@/classes/bookings/PreJobRoadBookingValidation";
import {PickStockValidation} from "@/classes/stock/PickStockValidation";
import QuoteValidation from "@/classes/quote/QuoteValidation";

export default class ValidationViewModel {
    constructor() {

        this.freightBooking = new FreightBookingValidation();
        this.courierBooking = new CourierBookingValidation();
        this.preJobAir = new PreJobAirBookingValidation();
        this.preJobSea = new PreJobSeaBookingValidation();
        this.preJobRoad = new PreJobRoadBookingValidation();
        this.preJobRail = new PreJobRoadBookingValidation(); // re-use

        this.pickStock = new PickStockValidation();
        this.quote = new QuoteValidation();

    }

}
